import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { getStickyLinks } from "../../../modules/homePage/homepageApiCalls";
import { TAB_VIEW_WIDTH } from "../../constants/constants";
import ImageIcon from "@mui/icons-material/Image";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";

const useStyles = makeStyles({
  stickyItem: {
    height: "50px",
    width: "50px",
    zIndex: 5,
    backgroundColor: "#1f1f1f",
    marginBottom: "2px",
    overflow: "hidden",
    transition: "0.5s",
    whiteSpace: "nowrap",
    color: "white",
    transform: "translate(-100%, 0)",
  },
  wrapper: {
    position: "fixed",
    top: "45%",
    left: "100%",
    zIndex: 5,
  },
  stickyItemMobile: {
    height: "60px",
    zIndex: 5,
    backgroundColor: "#1f1f1f",
    marginBottom: "2px",
    overflow: "hidden",
    transition: "0.5s",
    whiteSpace: "nowrap",
    color: "white",
    width: "100%",
    border: "1.5px solid black",
  },
  wrapperMobile: {
    position: "fixed",
    width: "100%",
    display: "flex",
    justifyContent: "space-evenly",
    backgroundColor: "#1f1f1f",
    bottom: 0,
    zIndex: 5,
  },
});
const LinkComp = styled(Link)(() => ({}));
const handleLinkClick = (target, url) => {
  if (target === "_blank") window.open(url, "_blank");
};
const StickyItemBar = ({ stickyLink }) => {
  const [stickyIcon, setStickyIcon] = useState(
    process.env.REACT_APP_BASEURL + stickyLink?.thumbnailImage?.url
  );
  const handleError = () => {
    setStickyIcon(ImageIcon);
  };
  useEffect(() => setStickyIcon(stickyIcon), [stickyIcon]);
  return (
    <LinkComp
      to={stickyLink?.target === "_blank" ? "#" : stickyLink?.url}
      onClick={() => handleLinkClick(stickyLink.target, stickyLink.url)}
      style={{
        display: "flex",
        alignItems: "center",
        textDecoration: "none",
      }}
    >
      <img
        width="25px"
        height="25px"
        style={{ padding: "12px" }}
        src={stickyIcon}
        alt={stickyLink?.title}
        onError={handleError}
      />
      <span
        style={{
          paddingLeft: "5px",
          color: "#ffffff",
          fontSize: "14px",
          fontFamily: "'Arial',sans-serif",
        }}
      >
        {stickyLink?.title}
      </span>
    </LinkComp>
  );
};

const StickyItemBarMobile = ({ stickyLink }) => {
  const [stickyIcon, setStickyIcon] = useState(
    process.env.REACT_APP_BASEURL + stickyLink?.thumbnailImage?.url
  );
  const handleError = () => {
    setStickyIcon(ImageIcon);
  };
  useEffect(() => setStickyIcon(stickyIcon), [stickyIcon]);
  return (
    <LinkComp
      to={stickyLink?.target === "_blank" ? "#" : stickyLink?.url}
      onClick={() => handleLinkClick(stickyLink.target, stickyLink.url)}
      style={{
        display: "flex",
        alignItems: "center",
        textDecoration: "none",
        flexDirection: "column",
      }}
    >
      <img
        width="25px"
        height="25px"
        style={{ paddingTop: "10px" }}
        src={stickyIcon}
        alt={stickyLink?.title}
        onError={handleError}
      />
      <span style={{ color: "#ffffff" }}>{stickyLink?.title}</span>
    </LinkComp>
  );
};

const sortByOrder = (data) => {
  return data?.sort((a, b) => a.order - b.order);
};
export default function StickyLinks() {
  const [stickyLinksData, setStickyLinksData] = useState([]);

  const matchesTab = useMediaQuery(TAB_VIEW_WIDTH);
  const styles = useStyles();

  useEffect(() => {
    getStickyLinks().then(({ data }) => {
      setStickyLinksData([...sortByOrder(data.menu.items)]);
    });
  }, []);

  const handleHover = (option) => () => {
    document.getElementById(option).style.width = "200px";
  };
  const handleLeave = (option) => () => {
    document.getElementById(option).style.width = "50px";
  };
  return (
    <>
      {matchesTab ? (
        <div className={styles.wrapper} id="stickyLinks">
          {stickyLinksData &&
            stickyLinksData.map((stickyLink) => (
              <div
                key={stickyLink.url}
                id={stickyLink.id}
                className={styles.stickyItem}
                onMouseEnter={handleHover(stickyLink.id)}
                onMouseLeave={handleLeave(stickyLink.id)}
              >
                <StickyItemBar stickyLink={stickyLink} />
              </div>
            ))}
        </div>
      ) : (
        <div className={styles.wrapperMobile} id="stickyLinksMobile">
          {stickyLinksData &&
            stickyLinksData.map((stickyLink) => (
              <div
                key={stickyLink.url}
                id={stickyLink.id}
                className={styles.stickyItemMobile}
              >
                <StickyItemBarMobile stickyLink={stickyLink} />
              </div>
            ))}
        </div>
      )}
    </>
  );
}
